module.exports = __webpack_public_path__ + "img/radiate.3fea7864.svg";